import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { ChiSiamoComponent } from './pages/chi-siamo/chi-siamo.component';
import { TablesAgGridComponent } from './pages/tables-ag-grid/tables-ag-grid.component';
import { MeteoComponent } from './pages/meteo/meteo.component';
import { TempoRealeComponent } from './pages/tempo-reale/tempo-reale.component';
import { NewsComponent } from './pages/news/news.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { DatiComponent } from './pages/dati/dati.component';
import { DocumentiComponent } from './pages/documenti/documenti.component';
import { DisclaimerComponent } from './pages/disclaimer/disclaimer.component';
import { IctRadioComponent } from './pages/ict-radio/ict-radio.component';
import { RicercaElementiComponent } from './pages/ricerca-elementi/ricerca-elementi.component';

const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: LandingPageComponent },
    { path: 'tables', component: TablesAgGridComponent },
    { path: 'chi-siamo', component: ChiSiamoComponent },
    { path: 'meteo', component: MeteoComponent },
    { path: 'meteo/:sezione', component: MeteoComponent },
    { path: 'tempo-reale', component: TempoRealeComponent },
    { path: 'dati', component: DatiComponent },
    { path: 'news', component: NewsComponent },
    { path: 'news/:id', component: NewsComponent },
    { path: 'documenti', component: DocumentiComponent },
    { path: 'disclaimer/:mod', component: DisclaimerComponent },
    { path: 'ict-radio', component: IctRadioComponent },
    { path: 'ricerca', component: RicercaElementiComponent },
    // { path: 'components', component: ComponentsComponent },
    // { path: 'nucleoicons', component: NucleoiconsComponent },
    // { path: 'examples/landing', component: LandingComponent },
    // { path: 'examples/login', component: LoginComponent },
    // { path: 'examples/profile', component: ProfileComponent },
    { path: '**', component: ErrorPageComponent }
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'disabled', // Disabilitiamo la gestione predefinita dello scroll
            anchorScrolling: 'enabled', // Abilitiamo lo scrolling sugli anchor
            scrollOffset: [0, 0] // Evita problemi di offset dovuti alla navbar
        })
        
    ],
    exports: [
    ],
})
export class AppRoutingModule { }
